import { AppShell } from './AppShell'

export function SidebarLayout() {
  return <AppShell />
}
